export default __webpack_public_path__ + "static/media/ChamferTurningImg.6297bea5.jpg";